var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiletype(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5C6.46875 0.5 5.625 1.34375 5.625 2.375V28.625C5.625 29.6562 6.46875 30.5 7.5 30.5H26.25C27.2812 30.5 28.125 29.6562 28.125 28.625V8L20.625 0.5H7.5Z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8H28.125L20.625 0.5V6.125C20.625 7.15625 21.4688 8 22.5 8Z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 13.625L22.5 8H28.125V13.625Z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 24.875C24.375 25.3906 23.9531 25.8125 23.4375 25.8125H2.8125C2.29688 25.8125 1.875 25.3906 1.875 24.875V15.5C1.875 14.9844 2.29688 14.5625 2.8125 14.5625H23.4375C23.9531 14.5625 24.375 14.9844 24.375 15.5V24.875Z",
    fill: "#EB5757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96094 18.2626C5.96094 18.0151 6.15594 17.7451 6.47 17.7451H8.20156C9.17656 17.7451 10.0541 18.3976 10.0541 19.6482C10.0541 20.8332 9.17656 21.4932 8.20156 21.4932H6.95V22.4832C6.95 22.8132 6.74 22.9998 6.47 22.9998C6.2225 22.9998 5.96094 22.8132 5.96094 22.4832V18.2626ZM6.95 18.6892V20.5567H8.20156C8.70406 20.5567 9.10156 20.1132 9.10156 19.6482C9.10156 19.1242 8.70406 18.6892 8.20156 18.6892H6.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5214 22.9997C11.2739 22.9997 11.0039 22.8647 11.0039 22.5356V18.2775C11.0039 18.0084 11.2739 17.8125 11.5214 17.8125H13.238C16.6636 17.8125 16.5886 22.9997 13.3055 22.9997H11.5214ZM11.9939 18.7275V22.0856H13.238C15.262 22.0856 15.352 18.7275 13.238 18.7275H11.9939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8048 18.7875V19.979H19.7164C19.9864 19.979 20.2564 20.249 20.2564 20.5106C20.2564 20.7581 19.9864 20.9606 19.7164 20.9606H17.8048V22.5347C17.8048 22.7972 17.6183 22.9987 17.3558 22.9987C17.0258 22.9987 16.8242 22.7972 16.8242 22.5347V18.2765C16.8242 18.0075 17.0267 17.8115 17.3558 17.8115H19.9873C20.3173 17.8115 20.5123 18.0075 20.5123 18.2765C20.5123 18.5165 20.3173 18.7865 19.9873 18.7865H17.8048V18.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 25.8125H5.625V26.75H23.4375C23.9531 26.75 24.375 26.3281 24.375 25.8125V24.875C24.375 25.3906 23.9531 25.8125 23.4375 25.8125Z",
    fill: "#CAD1D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletype);
export default __webpack_public_path__ + "static/media/filetype.89c0eda45e0a8683492865cccc567833.svg";
export { ForwardRef as ReactComponent };